import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Switch } from 'react-router';
import Ranking from './Ranking';
import Info from './Info';
import InfoList from './InfoList';
import Proposal from './Proposal'
import ProposalList from './ProposalList'
import Pricing from './Pricing';
import Lottery from './Lottery'
import Contact from './Contact'
import CancelSubscription from './CancelSubscription'
import PageNotFound from './404'
import NerverDie5566 from './5566'
import PrivacyPolicy from './PrivacyPolicy'
import TermofService from './TermofService'
import './assets/index.css';
import Background from './Background'
import Siderbar from './Sidebar';
import Nav from './Nav';
import Payment from './Payment'
import Footer from './Footer'
import User from './User'
import UserInfo from './UserInfo';
import UserActive from './User/UserActive'
import UserMobile from './UserMobile';
import EditPassword from './UserInfo/EditPassword';
import AgencyPayment from './Payment/AgencyPayment'
import IntlProvider from './IntlProvider';
import CurrentSubscriber from './CurrentSubscriber';
const App = props => {
    const { user: {isActive}, payment:{ isPaymentActive, isPaymentGuideActive} } = props
    return (
        <IntlProvider>
            <Router>
                <React.Fragment>
                    <Background isUserActive={isActive}>
                        <Siderbar />
                        <Nav />
                        <Switch>
                            <Route exact path="/" component={Ranking} />
                            <Route path="/Info/:infoId" component={Info} />
                            <Route path="/InfoList" component={InfoList} />
                            <Route path="/Proposal/:proposalId" component={Proposal} />                            
                            <Route path="/Proposal" component={ProposalList} />
                            <Route path="/Pricing" component={Pricing} />
                            <Route path="/Pricing" component={Pricing} />
                            <Route path="/Contact" component={Contact} />
                            <Route path="/CancelSubscription" component={CancelSubscription} />
                            <Route path="/Lottery" component={Lottery} />
                            <Route path="/AgencyPayment/:condition" component={AgencyPayment} />
                            <Route path="/NerverDie5566" component={NerverDie5566} />
                            <Route path="/PrivacyPolicy" component={PrivacyPolicy} />
                            <Route path="/TermofService" component={TermofService} />
                            <Route path="/EditPassword" component={EditPassword} />
                            <Route path="/UserInfo" component={UserInfo} />
                            <Route path="/UserMobile" component={UserMobile} />
                            <Route path="/accounts/:condition/:id/:email?/" component={UserActive} />
                            <Route path="/CurrentSubscriber/:creatorId" component={CurrentSubscriber} />
                            <Route component={PageNotFound} />
                        </Switch>
                        {(isPaymentActive || isPaymentGuideActive) && <Payment/>}
                    </Background>
                    <User isUserActive={isActive}/>
                    <Footer />
                </React.Fragment>
            </Router>
        </IntlProvider>
    )
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment
    }
}
export default connect(mapStateToProps)(App);




// WEBPACK FOOTER //
// ./src/App.js